import { WORK_LOCATION } from './worklog';

export const UPDATE_QUICK_WFH_ACTION_MESSAGE = 'I am working remotely today.';
export const UPDATE_QUICK_WFO_ACTION_MESSAGE = 'I am working from office today.';
export const QUICK_WFH_ACTION_ACTIVE_MESSAGE = 'You are working remotely today.';
export const QUICK_WFO_ACTION_ACTIVE_MESSAGE = 'You are working from office today.';
export const QUICK_ACTION_BUTTON_DISABLED_MESSAGE = "You have already updated your today's status.";
export const QUICK_ACTION_UPDATED_WORKLOG_MESSAGE = "You have already filled today's worklog.";
export const QUICK_ACTION_UPDATE_WORKLOG_MESSAGE = "Fill today's worklog";
export const QUICK_ACTION_REQUEST_LEAVE_MESSAGE = 'Request leave for today';
export const QUICK_ACTION_APPLIED_LEAVE_MESSAGE = 'You are on leave today.';
export const QUICK_ACTION_INACTIVE_REQUEST_LEAVE_MESSAGE = 'Request leave';
export const QUICK_ACTION_FREEZE_MESSAGE = 'Apply missing attendance';

export const UPDATE_ATTENDANCE_STATUS_TOAST_MESSAGE = {
  [WORK_LOCATION.OFFICE]: 'You are all set to work from office for today.',
  [WORK_LOCATION.HOME]: 'You are all set to work remotely for today.',
};

export const APPROVE_LEAVE_REQUEST_MESSAGE = 'Leave request has been approved!';
export const REJECT_LEAVE_REQUEST_MESSAGE = 'Request has been rejected!';

export const QUICK_ACTION_REQUEST_REMOTE_WORK = 'Request remote work';
export const QUICK_ACTION_REMOTE_WORK_ACTIVE = 'You have requested for remote work today';
export const QUICK_ACTION_ROSTER_CONFLICT_MESSAGE =
  'Please submit a remote work request before applying for remote work.';
